<div class="feature-group d-flex flex-wrap justify-content-center">
  <div
    *ngFor="let item of items; let i = index"
    class="feature-item text-center p-3"
    [ngClass]="getItemClass(i)"
  >
    <div class="feature-item__image mb-3">
      <img [src]="item.image" class="img-fluid" alt="{{ item.title }}" />
    </div>
    <h5 class="feature-item__title">{{ item.title }}</h5>
    <p class="feature-item__description">{{ item.description }}</p>
  </div>
</div>
